import { useFirstRunEntered } from "../hooks/useFirstRunEntered";
import { useIngestionProgress } from "../api/useIngestionProgress";
import { useIsSPAPIConnected } from "../../../hooks/useIsSPAPIConnected";
import { useAppSelector } from "../../../redux/hooks";
import { FirstRunTakeover } from "./FirstRunTakeover";
import { DashboardBanner } from "./DashboardBanner";

export const WorkflowProgressV2Banner = () => {
  const { model } = useIngestionProgress();
  const { entered, markEntered } = useFirstRunEntered();
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const initialDataLoadedOn = useAppSelector((state) => state.user.initial_data_loaded_on);
  const isSPAPIConnected = useIsSPAPIConnected();
  const spApiMissing = channel === "amazon" && !isSPAPIConnected;

  if (!model.shouldShow) return null;

  if (initialDataLoadedOn !== null) {
    if (!model.isComplete) return null;
    return <DashboardBanner model={model} spApiMissing={spApiMissing} />;
  }

  if (!entered) return <FirstRunTakeover model={model} onEnter={markEntered} spApiMissing={spApiMissing} />;

  return <DashboardBanner model={model} spApiMissing={spApiMissing} />;
};
